<template>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" :destroy-on-close="true"
        :before-close="cancel">
        <el-table :data="contacts" size="mini" border max-height="300" style="width: 100%; margin-bottom: 16px;">
            <el-table-column type="index" label="编号" width="60" align="center"></el-table-column>
            <el-table-column prop="contactName" label="客户姓名" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="当前销售" min-width="120" show-overflow-tooltip>
                <template slot-scope="{row}">{{ row.sales && row.sales.name ? row.sales.name : '-' }}</template>
            </el-table-column>
            <el-table-column prop="phone" label="电话号码" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="180" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-form label-width="120px">
            <el-form-item label="更改为销售">
                <el-select v-model="salesUuid" placeholder="请选择要更改的销售" filterable style="width: 100%;">
                    <el-option v-for="item in salesOptions" :key="item.uuid" :label="item.name"
                        :value="item.uuid"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>

import { getPersonByType, getPersonById } from "@/api/dilivery/customer/person";
import { editUserSales } from "@/api/dilivery/customer/user";
import { getDataInLocalStorage } from "@/utils/localStorage";

export default {
    name: "ChangeContactSales",
    props: ['showDialog', 'contacts'],
    data() {
        return {
            title: '批量更改客户联系人销售',
            salesUuid: '',
            salesOptions: [],
            role: '',
            userData: {},
        }
    },
    mounted() {
        this.getSalesOptions()
    },
    created() {
        this.userData = JSON.parse(getDataInLocalStorage('user'))
        this.role = getDataInLocalStorage('role')
    },
    methods: {
        getSalesOptions() {
            try {
                if (['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER', 'SALES_ASSI'].includes(this.role)) {
                    getPersonByType('SALES', {}).then(res => {
                        if (res.code === 200) {
                            this.salesOptions = res.data
                        }
                    }).catch(err => { })
                } else {
                    getPersonById(this.userData['personUuids'][0], {}).then(res => {
                        if (res.code === 200) {
                            this.salesOptions = res.data
                        }
                    }).catch(err => { })
                }
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取销售信息失败');
            }
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        handle() {
            if (!this.salesUuid) {
                this.$messageUi.error('请选择要更改的销售')
                return
            }
            const data = {
                customerContactsIds: this.contacts.map(item => item.id),
                salesUuid: this.salesUuid
            }
            editUserSales(data).then(res => {
                if (res.code === 200) {
                    const result = res.data || {}
                    const successCount = result.successCount || 0
                    const failCount = result.failCount || 0
                    const failReasons = result.failReasons || []
                    if (failCount > 0) {
                        // 存在失败：弹窗展示成功/失败数量及失败明细，全部失败则不刷新
                        const listHtml = failReasons.map(item => {
                            const name = this.escapeHtml(item.name || ('ID:' + item.id))
                            const reason = this.escapeHtml(item.reason || '更改失败')
                            return '<li>' + name + '：' + reason + '</li>'
                        }).join('')
                        const html = '<div>成功 ' + successCount + ' 条，失败 ' + failCount + ' 条。</div>'
                            + (listHtml ? '<ul style="margin:8px 0 0;padding-left:18px;">' + listHtml + '</ul>' : '')
                        const refresh = () => {
                            if (successCount > 0) {
                                this.$emit('submit', 'confirm')
                            }
                        }
                        this.$alert(html, '更改结果', {
                            dangerouslyUseHTMLString: true,
                            type: successCount > 0 ? 'warning' : 'error',
                            confirmButtonText: '确定'
                        }).then(refresh).catch(refresh)
                    } else {
                        this.$emit('submit', 'confirm')
                        this.$messageUi.success('修改成功')
                    }
                }
            }).catch(err => {
            })
        },
        escapeHtml(str) {
            return String(str).replace(/[&<>"']/g, s => ({
                '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
            })[s])
        }
    }
}
</script>

<style scoped>

</style>
